import { createSelector } from '@reduxjs/toolkit';
import find from 'lodash/find';

import { Mask } from 'types';

import { State } from './types';
import { RootState } from '../root-reducer';
import { translationLanguageCodesSelector } from '../translation-languages/selectors';

const rootSelector = (state: RootState): State => state.Masks;

export const statusSelector = createSelector(rootSelector, (masks) => masks.status);

export const errorSelector = createSelector(rootSelector, (masks) => masks.error);

export const masksSelector = createSelector(rootSelector, (masks) => masks.data);

export const masksWithEnabledTranslationsSelector = createSelector(
  masksSelector,
  translationLanguageCodesSelector,
  (masks, translationLanguageCodes) => {
    const languageCodeOrderMap = new Map(translationLanguageCodes.map((code, index) => [code, index]));

    const masksWithEnabledTranslations: Mask[] = masks.map((mask) => {
      return {
        ...mask,
        templates: mask.templates.map((template) => ({
          ...template,
          mailConfiguration: {
            ...template.mailConfiguration,
            translations: template.mailConfiguration.translations
              .filter((translation) => translationLanguageCodes.includes(translation.languageCode))
              .sort((a, b) => {
                const orderA = languageCodeOrderMap.get(a.languageCode) ?? Infinity;
                const orderB = languageCodeOrderMap.get(b.languageCode) ?? Infinity;
                return orderA - orderB;
              }),
          },
        })),
      };
    });
    return masksWithEnabledTranslations;
  }
);

export const maskByIdSelector = (maskId: number) => {
  return createSelector(masksSelector, (masks) => {
    return find(masks, { templates: [{ id: maskId }] });
  });
};

export const TemplateByMaskIdSelector = (maskId: number) => {
  return createSelector(maskByIdSelector(maskId), (maskById) => {
    return find(maskById?.templates, { id: maskId });
  });
};

export const selectedMaskSelector = createSelector(rootSelector, (state) => state.selectedMask);

export default {
  statusSelector,
  errorSelector,
  masksSelector,
  masksWithEnabledTranslationsSelector,
  maskByIdSelector,
  TemplateByMaskIdSelector,
  selectedMaskSelector,
};
